var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "news-section" },
    [
      _c("header-inner"),
      _vm.entry && _vm.entry.title
        ? _c(
            "wrapper",
            [
              _c("menu-news"),
              _c(
                "article-page",
                {
                  attrs: {
                    content: _vm.entry,
                    "back-url": "/news/#tagId" + this.$route.params.category,
                    "back-title": "Вернуться к списку новостей"
                  }
                },
                [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.entry.text) }
                  })
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12041546", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12041546","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/news/_category/index.vue
// module id = DDsG
// module chunks = 4